import type {
  MultipleProductCard,
  SingularProductCard
} from "@shared/graphql.types";
import { Typography } from "@shared/ui.primitives";

import { HorizontalProductCardWrapper } from "packages/acquisition/shared/components/ProductCardWrapper/HorizontalProductCardWrapper";

import * as styles from "./PairsWith.css";

type Props = {
  productCards?: (SingularProductCard | MultipleProductCard)[];
  onAddToBag: (sku: string) => void;
};

export const PairsWith = ({ productCards = [], onAddToBag }: Props) => {
  return (
    <div className={styles.wrapper}>
      <Typography variant="subheader-3" colour="primary-dark">
        Pairs Well With
      </Typography>

      <ul className={styles.listContainer}>
        {productCards.map((card, index) => {
          return (
            <li className={styles.listItem} key={`header-image-${index}`}>
              <HorizontalProductCardWrapper
                location="pairsWith"
                productCard={card}
                styles={{ variant: "carousel", buttonVariant: "secondary" }}
                addToBasketOptions={{
                  afterAdd: () => {
                    const sku = card.variants?.[0]?.sku;
                    if (sku) {
                      onAddToBag?.(sku);
                    }
                  }
                }}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
